<template>
    <base-modal ref="baseModal" @resetform="resetForm()" :load-data="loadData" :send="send" :valid-form="isValid">
        <template v-slot:header>
            <h3>{{$t('switch_queues_title')}}</h3>
        </template>

        <h4>{{$t('choose_queues_text')}}:</h4><br>
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          @change="toggleAll"
        >
          {{ allSelected ? 'Un-select All' : 'Select All' }}
        </b-form-checkbox>
        <b-form-checkbox-group
            v-model="selected"
            :options="options"
            switches
        ></b-form-checkbox-group>
    </base-modal>
</template>
<script>
import BaseModal from "./BaseModal";
import {AgentService} from "../services/agent-service";
import {BFormCheckboxGroup, BFormCheckbox} from "bootstrap-vue";

export default {
	props: {agentService: AgentService, extension: String},
	data: () => ({queues: null, selected: [], indeterminate: false, allSelected: false}),
	components: {BaseModal, BFormCheckboxGroup, BFormCheckbox},
	methods: {
		open() {
			this.$refs.baseModal.open();
		},
		async loadData() {
			console.info("A: loading data...");
			let queuesResponse = await this.agentService.getQueues();
			this.queues = queuesResponse.data;
		},
		async send() {
			let result = await this.agentService.switchQueues({
				extension: this.extension,
				queues: this.selected.join(",")
			});
			if (result.status == "ok") {
				return "ok";
			}
		},
		resetForm() {
			console.info("reset form...", this);
			this.selected = [];
		},
		toggleAll(checked) {
			console.info("new array", this.options.slice());
			this.selected = checked ? this.options.slice().map(option => option.value) : [];
		}
	},
	computed: {
		options() {
			if (!this.queues || this.queues.length == 0) {
				return [];
			}
			return this.queues.map(queue => {
				return {text: queue.name, value: queue.id};
			});
		},
		isValid() {
			return this.selected.length > 0;
		}
	},
	watch: {
		selected(newVal, oldVal) {
			// Handle changes in individual flavour checkboxes
			if (newVal.length === 0) {
				this.indeterminate = false;
				this.allSelected = false;
			}
			else if (newVal.length === this.options.length) {
				this.indeterminate = false;
				this.allSelected = true;
			}
			else {
				this.indeterminate = true;
				this.allSelected = false;
			}
		}
	}
};
</script>
